import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { FIREBASE_CONFIG } from '../config';

// Initialize Firebase app
export const app = initializeApp(FIREBASE_CONFIG);

// Get Firestore instance
export const db = getFirestore(app);

// Common Firestore collections
export const COLLECTIONS = {
  FAMILIES: 'families',
  DEVICES: 'devices',
  POLICIES: 'policies',
  RESTRICTIONS: 'restrictions',
  SCHEDULES: 'schedules',
  USAGE: 'usage',
  EVENTS: 'events',
  AUDIT: 'audit',
  BYPASS_CODES: 'bypassCodes',
};
